import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Plane, Globe, GraduationCap, Users, ShieldAlert, Luggage, Clock, CheckCircle, HeartPulse } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const TravelInsurance = () => {
    const { t } = useLanguage();

    const travelPlans = [
        { key: 'ft_travel_dom', icon: Plane, desc: 'Highest coverage at lowest premium for any travel-related emergencies.' },
        { key: 'ft_travel_intl', icon: Globe, desc: 'International travel cover with cashless medical treatments.' },
        { key: 'ft_travel_stud', icon: GraduationCap, desc: 'Targeted for students abroad with study interruption cover.' },
        { key: 'ft_travel_fam', icon: Users, desc: 'One plan to cover your entire family on vacation globally.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_travel')}
                subtitle="Travel the world with zero worries. Experience the world's most comprehensive 24/7 travel safety net."
                bgGradient={true}
                image="/assets/travel-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Explore Your Journey Plans</h2>
                    <p className="section-subtitle">A diverse range of travel insurance solutions tailored for every kind of explorer.</p>
                </div>
                
                <div className="grid grid-3">
                    {travelPlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Superior Travel Care</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <HeartPulse className="feature-icon" />
                            <h4>Medical Emergencies</h4>
                            <p>Cashless hospitalization in international hospitals for sudden medical emergencies.</p>
                        </div>
                        <div className="feature-item">
                            <Luggage className="feature-icon" />
                            <h4>Lost Baggage</h4>
                            <p>Compensation for lost documents, baggage, and travel delays to keep you moving.</p>
                        </div>
                        <div className="feature-item">
                            <Clock className="feature-icon" />
                            <h4>24/7 Assistance</h4>
                            <p>Dedicated international helpline available round the clock in multiple languages.</p>
                        </div>
                        <div className="feature-item">
                            <ShieldAlert className="feature-icon" />
                            <h4>Trip Cancellation</h4>
                            <p>Recover non-refundable trip costs in case of mandatory trip cancellations.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Get Instant Travel Quote</h3>
                    <p>Enter your destination and travel dates for an optimized plan comparison.</p>
                    <button className="btn btn-primary" onClick={() => window.location.href='/contact'}>Compare Quotes</button>
                </div>
            </div>
        </div>
    );
};

export default TravelInsurance;
